import classNames from 'classnames'
import React, { useRef } from 'react'
import { getCurrentTime } from '../utils/date'
import s from './TimePicker.less'

// webpack:BrowserOnly
export default function DatePicker({ name, value, label, className, onChange }) {
  const now = getCurrentTime()
  const inputRef = useRef()

  // Accepted value property should respect ISO time format : HH:MM
  return (
    <>
      <label>
        {label}
        <input
          ref={inputRef}
          type="time"
          name={name}
          className={classNames(s.timeInput, className)}
          placeholder="hh:mm"
          required
          value={value || now}
          onChange={() => onChange?.(inputRef.current.value)}
        />
      </label>
    </>
  )
}
